import React, { useState } from "react";
import RadioOption, { RadioOptionProps } from "./RadioOption/RadioOption";

export interface RadioGroupProps {
  options: Omit<RadioOptionProps, 'selectedValue' | 'onChange'>[];
  defaultValue?: string;
  onChange?: (value: string) => void;
  className?: string;
}

const GenericRadioGroup: React.FC<RadioGroupProps> = ({ options, defaultValue, onChange }) => {
  const [selectedValue, setSelectedValue] = useState<string | undefined>(defaultValue);

  const handleChange = (value: string) => {
    setSelectedValue(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className="space-y-2">
      {options.map((option) => (
        <RadioOption
          key={option.value}
          {...option}
          selectedValue={selectedValue}
          onChange={handleChange}
        />
      ))}
    </div>
  );
};

export default GenericRadioGroup;
